import React from 'react';

import {
	MentionNodeComponentContext,
	type MentionNodeComponentContextValue,
} from './mention-node-component-context';

export const MentionNodeComponentProvider = ({
	respondedAgentId,
	disabledTooltip,
	children,
}: React.PropsWithChildren<MentionNodeComponentContextValue>): React.JSX.Element => {
	// Stabilise the context value so the per-mention MentionNodeComponent
	// consumers don't re-render every time the parent renderer re-renders
	// (e.g. on each streaming chunk) when these values are unchanged.
	const value = React.useMemo(
		() => ({ respondedAgentId, disabledTooltip }),
		[respondedAgentId, disabledTooltip],
	);
	return (
		<MentionNodeComponentContext.Provider value={value}>
			{children}
		</MentionNodeComponentContext.Provider>
	);
};
